export type WorkspaceView =
  | 'contributions'
  | 'catalogue'
  | 'operations'
  | 'quotes'
  | 'reviews'
  | 'reports'
  | 'board'
  | 'photos'
  | 'achievements';
export type BoardView = 'picks' | 'quizzes' | 'team' | 'moderation';

const paths: Record<WorkspaceView, string> = {
  contributions: '/catalogue-contributions',
  reviews: '/',
  quotes: '/quotes',
  reports: '/reader-reports',
  photos: '/photos',
  board: '/board',
  catalogue: '/catalogue',
  operations: '/operations',
  achievements: '/achievements',
};
const boardPaths: Record<BoardView, string> = {
  picks: '/board',
  quizzes: '/board/quizzes',
  team: '/board/team',
  moderation: '/board/moderation',
};

export function workspacePath(view: WorkspaceView): string {
  return paths[view];
}

export function workspaceViewFromPath(pathname: string): WorkspaceView {
  const path = pathname.replace(/\/+$/u, '') || '/';
  if (Object.values(boardPaths).includes(path)) {
    return 'board';
  }
  return (
    (Object.entries(paths).find(([, value]) => value === path)?.[0] as WorkspaceView | undefined) ??
    'reviews'
  );
}

export function boardPath(view: BoardView): string {
  return boardPaths[view];
}

export function boardViewFromPath(pathname: string): BoardView {
  const path = pathname.replace(/\/+$/u, '');
  return (
    (Object.entries(boardPaths).find(([, value]) => value === path)?.[0] as
      BoardView | undefined) ?? 'picks'
  );
}

export function workspaceReturnPath(state: unknown): string {
  const returnTo =
    state && typeof state === 'object' && 'returnTo' in state ? state.returnTo : null;
  return typeof returnTo === 'string' &&
    (Object.values(paths).includes(returnTo) || Object.values(boardPaths).includes(returnTo))
    ? returnTo
    : paths.reviews;
}
